module.exports = __webpack_public_path__ + "static/images/down-arrow.3iUOihD.svg";